<!--
 * @Description: 主容器
                        问题：noLayout的路由为缓存，如果需要缓存需要注册容器组件router-transition
 * @Date: 2021-09-23 17:33:36
-->
<template>
  <router-view class="router" :style="{ width: '100%', height: baseHeight }" />
</template>
<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from 'vue';
import appStore from '@/store';

// const route = useRoute();

// watch(
//   () => route,
//   v => {
//     console.log('app router change', v);
//   },
//   { deep: true, immediate: true }
// );

const baseHeight = ref('100vh');
const _setScale = () => {
  const screenWidth = window.innerWidth;
  const designWidth = screenWidth < 1200 ? 1200 : 1920;
  let scale = 1;

  if (screenWidth >= designWidth) {
    document.body.style.transform = `scale(${scale})`;
    document.body.style.transformOrigin = '0 0';
    document.body.style.width = `${window.innerWidth}px`;
    document.body.style.height = `${window.innerHeight}px`;
    document.body.style.position = 'relative';

    baseHeight.value = '100vh';
  } else {
    scale = screenWidth / designWidth;
    document.body.style.transform = `scale(${scale})`;
    document.body.style.transformOrigin = '0 0';
    document.body.style.width = `${designWidth}px`;
    document.body.style.height = `${window.innerHeight}px`;
    document.body.style.position = 'relative';

    baseHeight.value = `${window.innerHeight / scale}px`;
  }
};

onMounted(() => {
  appStore.useUserStoreSetup.initUserSystemData();

  console.log(document.body.style.width);
  console.log(window.innerWidth);

  // setScale();
  // window.addEventListener('resize', setScale);
});
onUnmounted(() => {
  // window.removeEventListener('resize', setScale);
});

console.log('启动方式：', process.env.NODE_ENV);
console.log('启动环境：', process.env.VUE_APP_SCENE);
console.log('启动版本：', process.env.VUE_APP_VERSION);
console.log('接口域名：', process.env.VUE_APP_PROXY);
console.log('Cors：', process.env.VUE_APP_DOMAIN);
</script>
<style lang="scss">
@import '~@/styles/unqualified.scss';
</style>
